import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { authStore } from './auth'
import globals from '@/plugins/globals'

export const lookupStore = defineStore('lookup', {
  state: () => ({
    lookups: {},
    optInInsurers: {},
    userRoles: [],
    repairPlanItems: [],
    vehicleScans: [],
    vehicleScan: null,
    loading: {
      lookups: false,
      userRoles: false,
      repairPlanItems: false,
      vehicleScans: false,
      vehicleScan: false
    }
  }),
  actions: {
    async getLookups(data) {
      const store = authStore()
      let _lookups = {}
      let _keys = data.keys.filter((k) => !this.lookups[k])
      let reset = false
      if (data.refresh) {
        reset = data.refresh
      }
      if (_keys.length || reset) {
        this.loading.lookups = true
        let results = await api.post(`lookup/byKeys`, {
          app: data.app ? data.app : null,
          keys: data.keys,
          firm: data.firm ? parseInt(data.firm) : parseInt(store.profile.firm),
          showInactive: false
        })
        this.loading.lookups = false
        if (results) {
          for (let key of data.keys) {
            _lookups[key] = []
            for (let item of results) {
              if (item.key.toLowerCase() === key.toLowerCase()) {
                item.codename = item.name
                item.name = item.value || item.name
                item.value = item.id || item.value
                item.isInactive = false
                _lookups[key].push(item)
              }
            }
          }
          this.lookups = JSON.parse(JSON.stringify(Object.assign(this.lookups, _lookups)))
        }
      }
      console.log('Got Lookups', this.lookups)
      return this.lookups
    },
    async getOptInInsurers(firm) {
      if (firm === undefined || firm === null) {
        return []
      }
      if (this.optInInsurers[firm]) {
        return this.optInInsurers[firm]
      }
      let results = await api.get(`blueprint/optInInsurers?firm=${firm}`)
      this.optInInsurers[firm] = Array.isArray(results) ? results : []
      console.log('Got Opt-In Insurers', firm, this.optInInsurers[firm])
      return this.optInInsurers[firm]
    },
    async getRoles(id, isProvider) {
      this.userRoles = []
      this.loading.userRoles = true
      if (id === undefined || id === null) {
        id = 1
      }
      let type = isProvider ? 5 : 3
      let roles = await api.get(`lookup/roles?firm=${id}&lookup=${type}`)
      if (roles) {
        roles.forEach((role) => {
          this.userRoles.push({
            id: role.role,
            value: role.role,
            name: role.name,
            description: role.description
          })
        })
      }
      console.log('Got Roles', this.userRoles)
      this.loading.userRoles = false
      return this.userRoles
    },
    async upsertLookup(data) {
      return await api.post('lookup/upsert', data)
    },
    async getRepairPlanItems(data) {
      this.repairPlanItems = []
      this.loading.repairPlanItems = true
      let results = await api.get(`blueprint/repairPlanItems?firm=${data.firm}&vehicleMake=${data.vehicleMake}&year=${data.year}`)
      this.loading.repairPlanItems = false
      if (results) {
        this.repairPlanItems = results
      }
      console.log('Got Repair Plan Items', this.repairPlanItems)
      return this.repairPlanItems
    },
    async getVehicleScans(vin) {
      this.vehicleScans = []
      this.loading.vehicleScans = true
      let results = await api.get(`blueprint/getScansByVIN?vin=${vin}`)
      this.loading.vehicleScans = false
      if (results) {
        this.vehicleScans = results
        this.vehicleScans = globals.sortArray(this.vehicleScans, 'created', 'desc')
      }
      console.log('Got Vehicle Scans', this.vehicleScans)
      return this.vehicleScans
    },
    async getScanFile(url) {
      this.vehicleScan = null
      this.loading.vehicleScan = true
      let response = await api.get(url)
      this.loading.vehicleScan = false
      if (response) {
        this.vehicleScan = JSON.parse(response)
      }
      console.log('Got Vehicle Scan', this.vehicleScan)
      return this.vehicleScan
    },
  }
})
